import React, {useState, useEffect, useContext, useReducer} from 'react';
import moment from 'moment';
import {scheduleReducer, auditReducer} from '../Utils/reducer.js';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import {Link, useParams, useHistory} from 'react-router-dom';
import AuditContext from '../Utils/context.js';
import {useLocalStorage} from 'react-use';
import {Button, Row, Col, Card, Dropdown, DropdownButton, Form} from 'react-bootstrap';
import axios from 'axios';
import {
  CustomPaging,
  PagingState,
  SortingState,
  IntegratedSorting,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-bootstrap4';
import { Loading } from 'components/Loading/loading';
import ExcelJS from 'exceljs';

const SORT_FIELD_MAP = {};

export default function Finding() {

  const {employeeId} = useParams();
  const {schedule} = useContext(AuditContext);
  // const [schedule, dispatchSchedule] = useReducer(scheduleReducer, null);
  const [auth] = useLocalStorage('authenticated');

  const [countOpen, setCountOpen] = useState(0);
  const [countComplete, setCountComplete] = useState(0);
  const [countProgress, setCountProgress] = useState(0);
  const [statusAction, setStatusAction] = useState('');
  const [picAction, setPicAction] = useState('');
  const [listPic, setListPic] = useState([]);

  const history = useHistory();
  const [swal, setSwal] = useAlert();
  const [schedules, setSchedules] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [columns] = useState([
    {name: 'ACTIONS', title: 'Action', getCellValue: row => {

      let variant = `primary`, label = `Open`;
      switch (row.ANSWER_ACTION_STATUS) {
        case 'COMPLETED':
          variant = `success`;
          label = row?.COMPLETED_AT ? moment(row.COMPLETED_AT, 'DD-MMM-YYYY').format('DD MMM YYYY') : ``;
          break;
        case `IN PROGRESS`:
          variant = `warning`;
          label =  'In Progress';
      }

      return (
        <Link to={`/auditor/${employeeId}/actions/${row.ANSWER_ACTION_ID}/edit`}>
          <Button variant={variant} size="sm">{label}</Button>
        </Link>
      )
    }},
    {name: 'ANSWER_ACTION_ID', title: 'ID', getCellValue: row => row.ANSWER_ACTION_ID},
    {name: 'CRITERIA', title: 'Criteria', getCellValue: row => row?.answer?.form?.criteria.CRITERIA_LABEL ?? `n-a`},
    {name: 'EVALUATE_DESC', title: 'Evaluation', getCellValue: row => row?.answer.EVALUATE_DESC ?? `n-a`},
    {name: 'CAUSE_DESC', title: 'Finding', getCellValue: row => row?.answer.CAUSE_DESC ?? `n-a`},
    {name: 'TYPE', title: 'Type', getCellValue: row => row?.actionType.ACTION_TYPE_NAME ?? `n-a`},
    // {name: 'ACTION_PLAN', title: 'Action Plan', getCellValue: row => row.PLAN_DESC ?? `n-a`},
    {name: 'DUE_DATE', title: 'Due Date', getCellValue: row => moment(row.DUE_DATE, 'DD-MMM-YYYY').format(`DD MMM YYYY`) ?? `n-a`},
    {name: 'PIC', title: `PIC`, getCellValue: row => row?.pics?.map(pic => pic?.employee?.EMP_NAME).join(`, `)},

  ]);
  const [defaultColumnWidths] = useState([
    {columnName: 'ACTIONS', width: 100 },
    { columnName: 'ANSWER_ACTION_ID', width: 60 },
    { columnName: 'CRITERIA', width: 200 },
    {columnName: 'EVALUATE_DESC', width: 180 },
    {columnName: 'CAUSE_DESC', width: 180 },
    {columnName: 'TYPE', width: 180 },
    // {columnName: 'ACTION_PLAN', width: 180 },
    {columnName: 'DUE_DATE', width: 180 },
    {columnName: 'PIC', width: 180 },
    {columnName: 'STATUS', width: 180 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'ANSWER_ACTION_ID', direction: 'asc' }]);

  const [rows, setRows] = useState([]);

  const [rowschedule, setRowschedule] = useState([]);

  const getRowId = row => row.ANSWER_ACTION_ID;

  const [type, setType] = useState(schedule.SCHEDULE_ID);
  const [year, setYear] = useState(schedule.START_DATE);

  const fetchAnswerActions = async () => {

    setLoading(true);
    fetchCountingAnswerActions();
    fetchListPIC(type);
    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          // SCHEDULE_ID: schedule.SCHEDULE_ID,
          SCHEDULE_ID: type,
          expand: `auditee.department,answer.form.criteria,pics.employee,actionType`,
          page: currentPage + 1,
          'per-page': pageSize,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);
      history.push(`/auditor/${auth.employee.EMP_ID}/audits/${type}/findings`);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const fetchSchedules = async () => {

    try {

      setLoading(true);

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedules`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: `auditee.department,instrument.standard`,
          sort: `-SCHEDULE_ID`,
          // page: currentPage + 1,
          // 'per-page': pageSize,
          'search': schedule.auditee.department.DEPT_NAME,
          // AUDITOR_TEAMS__EMP_ID: employeeId,
          // sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });
      const newSchedule = [];
      if (response.data._meta.totalCount >= 1){
        let k = 0;
        response.data.items.map((name) => {
          if (name.auditee.department.DEPT_NAME === schedule.auditee.department.DEPT_NAME){
            newSchedule.push(response.data.items[k]);
            k += 1;
          } else {
            k += 1
          }
        })
        setSchedules(newSchedule);
      } else {
        setSchedules(response.data.items);
      }

    } catch (error) {
      alert(error)
    }
  };

  const fetchCountingAnswerActions = async () => {

    try {
      setCountOpen(0)
      setCountProgress(0)
      setCountComplete(0)
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/count-status`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: type
        }
      });
      response.data.result.forEach(data => {
        if(data.ANSWER_ACTION_STATUS=='OPEN'){
          setCountOpen(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='IN PROGRESS'){
          setCountProgress(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='COMPLETED'){
          setCountComplete(data.JUMLAH)
        }
      })

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const fetchSearchAnswerActions = async () => {

    setLoading(true);

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          SCHEDULE_ID: type,
          expand: `answer.form.criteria,pics.employee,actionType`,
          ANSWER_ACTION_STATUS: statusAction,
          picstest: picAction
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const handleType = (event) => {
    fetchListPIC(event.target.value)
    setType(event.target.value)
  }

  const fetchListPIC = async (scheduleId) => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/list-pic`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: scheduleId
        }
      });
      if(response.data.result.length>0){
        setListPic(response.data.result)
      }else{
        setListPic([])
      }

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const handleExportToExcel = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/finding-export-excel`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: type
        }
      });

      const dataResult = response.data.result;

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Audit Findings');

      // 2. Define Columns (Mapping keys to your SQL query results)
      worksheet.columns = [
        { header: 'No', key: 'no', width: 5 },
        { header: 'Answer Action Id', key: 'ANSWER_ACTION_ID', width: 10 },
        { header: 'Criteria', key: 'CRITERIA_LABEL', width: 25 },
        { header: 'Evaluation', key: 'EVALUATE_DESC', width: 50 },
        { header: 'Finding', key: 'CAUSE_DESC', width: 50 },
        { header: 'Action Plan', key: 'PLAN_DESC', width: 50 },
        { header: 'Type', key: 'ACTION_TYPE_NAME', width: 20 },
        { header: 'Due Date', key: 'DUE_DATE', width: 20 },
        { header: 'PIC Names', key: 'PIC_NAMES', width: 50 },
        { header: 'Status', key: 'ANSWER_ACTION_STATUS', width: 10 },
        { header: 'Reject Explain', key: 'REJECT_EXPLAIN', width: 50 },
      ];

      // 3. Add Rows from your API Result
      dataResult.forEach((item, index) => {
        worksheet.addRow({
          no: index + 1,
          ANSWER_ACTION_ID: item.ANSWER_ACTION_ID,
          CRITERIA_LABEL: item.CRITERIA_LABEL,
          EVALUATE_DESC: item.EVALUATE_DESC,
          CAUSE_DESC: item.CAUSE_DESC,
          PLAN_DESC: item.PLAN_DESC,
          ACTION_TYPE_NAME: item.ACTION_TYPE_NAME,
          DUE_DATE: item.DUE_DATE,
          PIC_NAMES: item.PIC_NAMES,
          ANSWER_ACTION_STATUS: item.ANSWER_ACTION_STATUS,
          REJECT_EXPLAIN: item.REJECT_EXPLAIN
        });
      });

      // 4. Make the Header Row look nice (Bold, Blue Background, White Text)
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '4F81BD' }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 5. Generate Buffer and Trigger Download (Vanilla JS way)
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `Finding_Report_${schedule.SCHEDULE_ID}.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.log(error);
      alert(`Error exporting excel`);
    }

    setLoading(false);
  };

  useEffect(fetchAnswerActions, [pageSize, currentPage]);
  useEffect(() => {
    fetchSchedules();
    return () => {}
  }, [])

  //useEffect(fetchCountingAnswerActions, [type]);

  return (
    <>
    <Row style={{width:"100%"}}>
      <Col md="12">
        <h4 style={{marginTop:1, fontWeight:'bold'}} >Summary of list {moment(schedule.START_DATE).format('YYYY')} Finding</h4>
        <div className="p-3 bg-light rounded shadow-sm border mb-4">

          <Row className="align-items-end mb-4">
            <Col xs={12} md={8} className="mb-3">
              <Form.Group className="mb-0">
                <Form.Label className="font-weight-bold small text-uppercase text-muted">
                  Select Years Finding / Instrument
                </Form.Label>
                <Form.Control
                  as="select"
                  className="custom-select"
                  defaultValue={-1}
                  name="SCHEDULE_ID"
                  onChange={handleType}
                >
                  <option value={-1}>Select Years Finding...</option>
                  {schedules && schedules.map((schedule, key) => (
                    <option key={key} value={schedule.SCHEDULE_ID}>
                      {moment(schedule.START_DATE).format('YYYY')} / {schedule.instrument.INSTRUMENT_NAME}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <Button variant="info" block onClick={fetchAnswerActions} style={{ height: 'calc(1.5em + .75rem + 2px)' }}>
                Generate Findings
              </Button>
            </Col>
          </Row>

          <hr />
          <Row className="align-items-end">
            <Col xs={12} sm={6} md={4} className="mb-3">
              <Form.Group className="mb-0">
                <Form.Label className="font-weight-bold small text-uppercase text-muted">
                  Filter Status
                </Form.Label>
                <Form.Control
                  as="select"
                  className="custom-select"
                  name="STATUS"
                  onChange={e => setStatusAction(e.target.value)}
                >
                  <option value="">Select Status...</option>
                  <option value='OPEN'>OPEN</option>
                  <option value='IN PROGRESS'>IN PROGRESS</option>
                  <option value='COMPLETED'>COMPLETED</option>
                  <option value=''>All</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={4} className="mb-3">
              <Form.Group className="mb-0">
                <Form.Label className="font-weight-bold small text-uppercase text-muted">
                  Filter PIC
                </Form.Label>
                <Form.Control
                  as="select"
                  className="custom-select"
                  onChange={e => setPicAction(e.target.value)}
                >
                  <option value="">Select PIC...</option>
                  {listPic.map(dataPIC => (
                    <option key={dataPIC.EMP_ID} value={dataPIC.EMP_ID}>
                      {dataPIC.FORMATTED_NAME}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <Button variant='primary' block onClick={fetchSearchAnswerActions} style={{ height: 'calc(1.5em + .75rem + 2px)' }}>
                Show Filtered
              </Button>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={12} sm={6} md={3} className="mb-2">
              <Button variant='outline-info' block size="sm" onClick={handleExportToExcel}>
                📊 Export Excel
              </Button>
            </Col>
          </Row>
          <Row className="text-center mt-2">
            <Col xs={4}>
              <div className="py-2 border rounded bg-white shadow-sm">
                <small className="text-muted d-block text-uppercase font-weight-bold">Open</small>
                <span className="h5 font-weight-bold text-primary">{countOpen}</span>
              </div>
            </Col>
            <Col xs={4}>
              <div className="py-2 border rounded bg-white shadow-sm">
                <small className="text-muted d-block text-uppercase font-weight-bold">In Progress</small>
                <span className="h5 font-weight-bold text-warning">{countProgress}</span>
              </div>
            </Col>
            <Col xs={4}>
              <div className="py-2 border rounded bg-white shadow-sm">
                <small className="text-muted d-block text-uppercase font-weight-bold">Completed</small>
                <span className="h5 font-weight-bold text-success">{countComplete}</span>
              </div>
            </Col>
          </Row>
        </div>
        <Grid
          rows={rows}
          columns={columns}
          getRowId={getRowId}
        >
          <PagingState
            currentPage={currentPage}
            onCurrentPageChange={setCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={setPageSize}
          />

          <SortingState
            sorting={sorting}
            onSortingChange={setSorting}
          />
          <IntegratedSorting />
          <CustomPaging totalCount={totalCount} />
          <Table />
          <TableColumnResizing
            columnWidths={columnWidths}
            onColumnWidthsChange={setColumnWidths}
          />
          <TableHeaderRow showSortingControls />
          <PagingPanel
            pageSizes={pageSizes}
          />
          {loading && <Loading />}
        </Grid>
      </Col>
    </Row>

    </>
  );
}